module.exports = __webpack_public_path__ + "img/112.2e2161f.jpg";